var Swiper = require("./libs/Swiper");
var Util = {
    getQueryString: function (name, url) {
        // 如果链接没有参数，或者链接中不存在我们要获取的参数，直接返回空
        if (url.indexOf("?") == -1 || url.indexOf(name + '=') == -1) {
            return '';
        }
        // 获取链接中参数部分
        var queryString = url.substring(url.indexOf("?") + 1);
        if (queryString.indexOf('#')>-1) {
            queryString = queryString.substring(0, queryString.indexOf('#'));
        };
        // 分离参数对 ?key=value&key2=value2
        var parameters = queryString.split("&");
        var pos, paraName, paraValue;
        for (var i = 0; i < parameters.length; i++) {
            // 获取等号位置
            pos = parameters[i].indexOf('=');
            if (pos == -1) {
                continue;
            }
            // 获取name 和 value
            paraName = parameters[i].substring(0, pos);
            paraValue = parameters[i].substring(pos + 1);
            // 如果查询的name等于当前name，就返回当前值，同时，将链接中的+号还原成空格
            if (paraName == name) {
                return unescape(paraValue.replace("+", " "));
            }
        }
        return '';
    },
    getQdValue: function () {
        var str = this.getQueryString('lwfrom', location.href);
        var prevUrl = document.referrer;
        if (str == "" && prevUrl) {
            if (this.getQueryString('lwfrom', prevUrl)) {
                str = this.getQueryString('lwfrom', prevUrl);
            } else {
                if (new RegExp('baidu.com').test(prevUrl)) {
                    str = 'baidu';
                } else if (new RegExp('google.com').test(prevUrl)) {
                    str = 'google';
                } else if (new RegExp('google.cn').test(prevUrl)) {
                    str = 'google';
                } else if (new RegExp('so.com').test(prevUrl)) {
                    str = '360';
                } else if (new RegExp('sogou.com').test(prevUrl)) {
                    str = 'sogou';
                } else if (new RegExp('bing.com').test(prevUrl)) {
                    str = 'bing';
                } else if (new RegExp('soso.com').test(prevUrl)) {
                    str = 'soso';
                }
            }
        }
        return str;
    },
    lwfromToqd: function () {
        var str = this.getQdValue();
        if (str != "") {
            var linklist = $(".download_log");
            var temp = 0;
            for (; temp < linklist.length; temp++) {
                var Href = linklist[temp].href;

                if (Href.indexOf('/qd=') > -1) {
                    var reg = /qd=.*?/;
                    var arr = Href.split(reg)
                    if (arr.length == 2) {
                        if (arr[1].indexOf("/") == -1) {
                            linklist[temp].href = Href.replace(arr[1], str);
                        } else {
                            linklist[temp].href = Href.replace(arr[1].substring(0, arr[1].indexOf('/')), str);
                            //console.log(linklist[temp].href);
                        }
                    }
                } else {
                    linklist[temp].href = linklist[temp].href + 'qd=' + str;
                }
            }
        }
    }
};

var qd = Util.getQdValue();
var ua = window.navigator.userAgent;
ua = ua.toLocaleLowerCase();
var isIOS = /(ipad|iphone|ipod)/g.test(ua);
var isAndroid = ua.indexOf('android') !== -1;
var isMicromessenger = ua.indexOf("micromessenger")>-1;
var url = "https://www.dingtalk.com/ios/d/";


if(isMicromessenger){
	url  = "http://a.app.qq.com/o/simple.jsp?pkgname=com.alibaba.android.rimet";
}else{
	if(isIOS){
		url = qd ? "https://www.dingtalk.com/ios/d/qd="+qd : "https://www.dingtalk.com/ios/d/";
	}else{
		url = qd ? "https://www.dingtalk.com/android/d/qd="+qd : "https://www.dingtalk.com/android/d/";
	}
}

$(".dd-download-btn").attr("href",url);

var bannerSwiper = new Swiper('.swiper-container', {
  pagination: '.swiper-pagination',
  paginationClickable: true,
  autoplay: 3000,
  loop: true
});



//////////////////
// WEBPACK FOOTER
// ./app/js/index-mobile.page.js
// module id = 0
// module chunks = 15